/**
 * Uniform random value in [0, 1) using `crypto.getRandomValues`.
 * Suitable for id suffixes and retry jitter (not for secrets).
 */
export function randomUnitInterval(): number {
  const buf = new Uint32Array(1);
  crypto.getRandomValues(buf);
  return buf[0]! / 0x1_0000_0000;
}

/** Generates a short base-36 segment for non-UUID event ids. */
export function randomBase36Segment(length: number): string {
  return randomUnitInterval()
    .toString(36)
    .slice(2, 2 + length)
    .padEnd(length, '0');
}
